export const PRIMARY_ROLE_ORDER = ['system_admin', 'boss', 'pricing_admin', 'sales'];
export function getUserRoles(user) {
    return user.roles?.length ? [...new Set(user.roles)] : [user.role];
}
export function hasRole(user, role) {
    return getUserRoles(user).includes(role);
}
export function primaryRole(roles) {
    return PRIMARY_ROLE_ORDER.find((role) => roles.includes(role)) ?? 'sales';
}
//# sourceMappingURL=roles.js.map